var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-menubar',{attrs:{"left_controls":_vm.lc,"nav_bgcolor":"bg-info"}})}
var staticRenderFns = []

export { render, staticRenderFns }